export const contacts: TableModule = {
    name: "contacts",
    route: "spa.system.contractors.contacts",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    routeParams: [{
        param: "contractor",
        prop: "contractor_id"
    }],
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "email",
            mobile: true,
        },
        {
            name: "phone",
            mobile: true,
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            name: "contacts.create",
            isCreateAction: true,
            ability: ["create", "contacts"]
        },
    ],
}